import { useState, useEffect } from "react";
import { UseAxios } from "../common/useAxios";
import defaultAxios from 'axios';
import { useAuth } from "../AuthContext";
import { backendUrl } from "../common/constantVarialble";

interface PrgHstInfo {
    program_id: string;
    seq: string; // 소스 버전
    sql: string;
    commit_msg: string;
    update_date: string;
    update_psn: string;
    current_seq: string; // 적용 버전
}

function CommitHistoryTab({ prgHstInfo, setPrgHstInfo, selectedSeq, setSelectedSeq, curretnSeq, setCurrentSeq, refreshProgramDetailPage }: { prgHstInfo: PrgHstInfo[], setPrgHstInfo: React.Dispatch<React.SetStateAction<any>>, selectedSeq: string, setSelectedSeq: React.Dispatch<React.SetStateAction<any>>, curretnSeq: string, setCurrentSeq: React.Dispatch<React.SetStateAction<any>>, refreshProgramDetailPage: () => void }) {

    //const [prgHstInfo, setPrgHstInfo] = useState<PrgHstInfo[]>([]);
    //const [selectedSeq, setSelectedSeq] = useState("");
    //const [curretnSeq, setCurrentSeq] = useState("");

    /*
    const { loading, data, error, refetch } = UseAxios({
        method: "post",
        url: "http://localhost:5000/api/request/",
        data: {
            program_id: "PERCENT-ADMIN-PRG-L-LSTPRGHST",
            params: {
                program_id: program_id,
            },
            page_index: -1,
        },
    });
*/

    /*
        useEffect(() => {
            console.log("parameter");
    
    
            const prgHstData = data?.data?.data;
    
    
    
            if (prgHstData) {
    
                setPrgHstInfo(prgHstData);
                console.log(prgHstInfo);
                setSelectedSeq(prgHstData[0].current_seq);
                setCurrentSeq(prgHstData[0].current_seq);
    
            }
        }, [data]);
        */

    const { user, userName } = useAuth();

    const onCommitVersionClick = (version: string) => {
        if (version !== "") {
            setSelectedSeq(version);
        }
    }

    const onCurrentVersionClick = () => {
        setSelectedSeq(curretnSeq);
    }

    const changeProgramVersion = async () => {
        try {

            const { data } = await defaultAxios({
                method: 'post',
                //url: 'http://localhost:5000/api/request/',
                url: backendUrl,
                data: {
                    program_id: 'PERCENT-ADMIN-PRG-C-UPDROLLBACKPRGPRM',
                    params: {
                        'p_program_id': prgHstInfo[0]?.program_id,
                        'p_seq': Number(selectedSeq),
                        'p_input_psn': userName
                    },
                    page_index: -1,
                },
            });

            return data;

        } catch (error) {
            console.error(error);
            return null;
        }
    }

    const onSwitchVersionClick = async () => {
        /*
        -- PERCENT-ADMIN-PRG-C-UPDROLLBACKPRGPRM
        -- FMR_PRG, FRM_PRM 롤백
        with val as(
            select $1::text as p_program_id,
                $2::INT as p_seq,
                $3::text as p_input_psn
        )
        select
            rollback_frm_prg_prm(val.p_program_id, val.p_seq, val.p_input_psn)
        from val;	


    const mergeSQLAndParameters = async () => {
        try {
            const paramString = prmInfo.map((p) => p.param_name).join(",");

            const { data } = await defaultAxios({
                method: 'post',
                url: 'http://localhost:5000/api/request/',
                data: {
                    program_id: 'PERCENT-ADMIN-PRG-C-UPDPRGPRM',
                    params: {
                        'p_program_id': SQLState?.program_id.trim(),
                        'p_param_list': paramString.trim(),
                        'p_prg_description': SQLState?.prg_description.trim(),
                        'p_sql': sql.trim(),
                        'p_input_psn': 'hbk',
                        'p_commit_msg': commitMsg.trim()
                    },
                    page_index: -1,
                },
            });

            return data;

        } catch (error) {
            console.error(error);
            return null;
        }
    }
        */
        console.log("change Version")
        const result = await changeProgramVersion();
        console.log(result);
        if (result && result.ok) {
            console.log("change Version Success")
            refreshProgramDetailPage();
        } else {
            alert(result.error);
        }

    }

    return (
        <div>


            <div
                className="flex flex-col md:grid grid-cols-9 mx-auto px-4 pt-2 text-blue-50 overflow-y-auto  w-full bg-gray-900"

                style={{ height: "65vh" }}
            >


                {/*style={{ maxHeight: '80vh' }}*/}
                {prgHstInfo.map((item, index) => (
                    <>
                        <div className="flex flex-row-reverse md:contents">
                            <div
                                className="col-start-1 col-end-4 py-4 rounded-xl my-4  flex flex-col items-center justify-center flex-1 text-sm"
                            >
                                <div className="flex flex-col">
                                    <span>Version {item.seq}</span>
                                    <span className="mb-1 leading-tight">{
                                        new Date(item.update_date).toLocaleString('en-US', {
                                            year: 'numeric',
                                            month: 'numeric',
                                            day: 'numeric',
                                            hour: 'numeric',
                                            minute: 'numeric',
                                            second: 'numeric',
                                            hour12: true, // 24-hour format
                                        })}
                                    </span>
                                    <span>commit by {item.update_psn}</span>
                                </div>

                            </div>
                            <div className="col-start-4 col-end-5 md:mx-auto relative mr-10">
                                <div className="h-full w-6 flex items-center justify-center">
                                    <div className="h-full w-1 bg-blue-600 pointer-events-none"></div>
                                </div>

                                {/* Commit Version select Radio button */}
                                <div
                                    className={` w-6 h-6 absolute top-1/2 -mt-3 rounded-full  focus:ring-0 focus:ring-offset-0 cursor-pointer 
                                ${selectedSeq === item.seq && item.seq === item.current_seq ? 'ring-4 ring-cyan-400' :
                                            (selectedSeq === item.seq ? 'ring-4 ring-slate-400' : 'ring-2 ring-slate-500 hover:ring-cyan-400')}`}
                                    onClick={() => onCommitVersionClick(item.seq ? item.seq : "")}
                                >
                                    {/* Outer circle (donut) */}
                                    <div className="absolute top-1/2 -mt-3 inset-0 rounded-full bg-gray-900"></div>
                                    {/* Inner circle (center) - drawn when checked */}

                                    <div className={`absolute inset-1 rounded-full                 
                                 ${selectedSeq === item.seq && item.seq === item.current_seq ? 'bg-cyan-400' :
                                            (selectedSeq === item.seq ? 'bg-slate-400' : 'bg-transparent')}`}></div>
                                </div>



                            </div>
                        </div>

                        <div className="flex md:contents">
                            <div className="col-start-5 col-end-10 p-4 rounded-xl my-4 shadow-md flex flex-col justify-center">
                                <h3 className="text-body mb-1">{item.commit_msg}</h3>
                            </div>
                        </div>
                    </>
                ))}

            </div>

            <div className="flex flex-row justify-center space-x-8 p-6 border-t border-gray-400">
                <div className="m-2" style={{ width: "40%" }}>
                    <button className="group relative h-10 w-full px-4 overflow-hidden rounded-2xl bg-slate-500 text-lg font-bold text-white" onClick={onCurrentVersionClick}>
                        Current version
                        <div className="absolute inset-0 h-full w-full scale-0 rounded-2xl transition-all duration-300 group-hover:scale-100 group-hover:bg-white/30"></div>
                    </button>
                </div>
                <div className="m-2" style={{ width: "40%" }}>
                    <button className="group relative h-10 w-full px-4 overflow-hidden rounded-2xl bg-slate-500 text-lg font-bold text-white" onClick={onSwitchVersionClick}>
                        Switch revision
                        <div className="absolute inset-0 h-full w-full scale-0 rounded-2xl transition-all duration-300 group-hover:scale-100 group-hover:bg-white/30"></div>
                    </button>
                </div>
            </div>


        </div>

    );
}

export { CommitHistoryTab };